import { createContext } from 'react';

import marketplace from 'cfg/marketplace.json';

export const MartyContext = createContext({
  testId: (id: string) => id,
  touchDetected: false,
  preventOnTouchDevice : (i: any) => i,
  marketplace,
  router: {}
});
